import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

export default {
  getSummary() {
    return axios.get(`${API_URL}/Monitoring/summary`);
  },

  getSqlSnapshot() {
    return axios.get(`${API_URL}/Monitoring/sql`);
  },

  resetDiagnostics() {
    return axios.post(`${API_URL}/Monitoring/reset-diagnostics`);
  },

  /** @param {number} [lines] @param {number} [maxKb] */
  getLogFile(lines = 400, maxKb = 512) {
    return axios.get(`${API_URL}/Monitoring/log-file`, {
      params: { lines, maxKb },
    });
  },
};
